jQuery(function ($) {
    const $root = $('body');

    // COPY CURRENT PAGE LINK (trailer) - reuse UniversalHelpers.copyToClipboard
    const $copyWrapper = $(".single-trailer-page .copy-current-url-wrapper");
    const $copySuccess = $copyWrapper.find(".copy-status-success");
    const $copyError = $copyWrapper.find(".copy-status-error");

    $root.on("click", ".single-trailer-page .single-car-hero-button-copy-url", function (e) {
        e.preventDefault();
        const currentUrl = window.location.href;

        const copyFn = (window.UniversalHelpers && typeof window.UniversalHelpers.copyToClipboard === 'function')
            ? window.UniversalHelpers.copyToClipboard.bind(window.UniversalHelpers)
            : null;

        if (!copyFn) {
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(currentUrl).then(function () {
                    $copyError.slideUp();
                    $copySuccess.slideDown();
                    setTimeout(function () { $copySuccess.slideUp(); }, 3000);
                }).catch(function () {
                    $copySuccess.slideUp();
                    $copyError.slideDown();
                    setTimeout(function () { $copyError.slideUp(); }, 3000);
                });
            } else {
                $copySuccess.slideUp();
                $copyError.slideDown();
                setTimeout(function () { $copyError.slideUp(); }, 3000);
            }
            return;
        }

        copyFn(currentUrl).then(function () {
            $copyError.slideUp();
            $copySuccess.slideDown();
            setTimeout(function () { $copySuccess.slideUp(); }, 3000);
        }).catch(function () {
            $copySuccess.slideUp();
            $copyError.slideDown();
            setTimeout(function () { $copyError.slideUp(); }, 3000);
        });
    });

    // EMAIL reveal (trailer)
    $root.on('click', '.single-trailer-page .reveal-email', function (e) {
        const $btn = $(this);
        if ($btn.data('revealed')) return;

        e.preventDefault();

        const fullEmail = $btn.data('full-email');
        const mailtoLink = $btn.data('mailto-link');
        if (!fullEmail) return;

        $btn.find('.email-text').text(fullEmail);
        if (mailtoLink) {
            $btn.attr('href', mailtoLink);
        }
        $btn.data('revealed', true);
        $btn.removeClass('reveal-email');
    });

    // PHONE reveal (trailer)
    $root.on('click', '.single-trailer-page .reveal-phone', function (e) {
        const $btn = $(this);
        if ($btn.data('revealed')) return;

        e.preventDefault();

        const fullPhone = $btn.data('full-phone');
        const telLink = $btn.data('tel-link');
        if (!fullPhone) return;

        $btn.find('.phone-text').text(fullPhone);
        if (telLink) {
            $btn.attr('href', telLink);
        }
        $btn.data('revealed', true);
        $btn.removeClass('reveal-phone');
    });

    // WHATSAPP reveal (trailer)
    $root.on('click', '.single-trailer-page .reveal-whatsapp', function (e) {
        const $btn = $(this);
        e.preventDefault();

        const encodedPhone = $btn.data('wa-phone');
        const encodedText = $btn.data('wa-text');
        if (!encodedPhone) return;

        try {
            const phone = atob(encodedPhone);
            let url = 'https://wa.me/' + phone;
            if (encodedText) {
                const text = atob(encodedText);
                url += '?text=' + text;
            }
            window.open(url, '_blank');
        } catch (err) {
            // ignore
        }
    });
});


